import React, { Component } from "react";
// import jdenticon from 'jdenticon';

class Header extends Component {
  render() {
    if (this.props.tableID && !this.props.error) {
      return (
        <nav className="navbar navbar-dark bg-dark mb-0">
          <span className="navbar-brand">
            <h5>{this.props.restaurantName}</h5>
            <div className="tableMeta">
              <span className="tableName">
              <h6>{this.props.tableName}</h6>
              </span>
              <span className="tableBill">
                {
                  this.props.tableTotal && 
                  <h6>${this.props.tableTotal}</h6>
                } 
              </span>
            </div>
          </span>
        {
          this.props.loggedInUser === "" ? (
            <div className="userNotAssigned"></div>
          ) : (
              <div className="userAssigned">
                <svg className="jdenticon" data-jdenticon-value={this.props.loggedInUser} width="62" height="62">
                  Fallback text or image for browsers not supporting inline svg.
                </svg>
                <div className="userNameLabel">YOU</div>
              </div>
              
            )
        }
        </nav>
      )
    } else {
      return (
        <div className="alert alert-danger" role="alert">
          Something went wrong. <br />Please scan again for a Table ID <small>(required)</small>
        </div>
      )
    }
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.js